export function round(n: number, digits: number): number {
  return Math.round(n * Math.pow(10, digits)) / Math.pow(10, digits);
}

export function roundTo2(n: number): number {
  return round(n, 2);
}
